import { COMPONENT_SIZE } from 'constants';

const colorsLightnessHighContrast = {
  light10: 5,
  light20: 10,
  light30: 20,
  light40: 30,
  light50: 50,
  light60: 60,
  light70: 70,
  light80: 80,
  light90: 90,
  light95: 95,
  light99: 99,
  light100: 100,
};
const colorsLightnessDefault = {
  light10: 10,
  light20: 20,
  light30: 30,
  light40: 40,
  light50: 50,
  light60: 60,
  light70: 70,
  light80: 80,
  light90: 90,
  light95: 95,
  light99: 99,
  light100: 100,
};

const voiceassistantDefault = {
  cursorPath: process.env.PUBLIC_URL + '/themes/assets/tactileo/voiceassistant/default/cursor.cur',
  iconReadAllPath:
    process.env.PUBLIC_URL + '/themes/assets/tactileo/voiceassistant/default/icon_readall.png',
  iconVoiceCommandPath:
    process.env.PUBLIC_URL + '/themes/assets/tactileo/voiceassistant/default/icon_voicecommand.png',
};
const voiceassistantChild = {
  cursorPath:
    process.env.PUBLIC_URL + '/themes/assets/tactileo/voiceassistant/child/cursor_readtext.png',
  iconReadAllPath:
    process.env.PUBLIC_URL + '/themes/assets/tactileo/voiceassistant/child/icon_readall.png',
  iconVoiceCommandPath:
    process.env.PUBLIC_URL + '/themes/assets/tactileo/voiceassistant/child/icon_voicecommand.png',
};

const avatarTactileoPath = {
  hasAnimations: true,
  avatarPath: process.env.PUBLIC_URL + '/themes/assets/tactileo/SmilingAvatar.svg',
  avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/tactileo/ResultLogo.svg',
  avatarWelcomePath: process.env.PUBLIC_URL + '/themes/assets/tactileo/welcome/welcome.html',
  avatarCorrectPath: process.env.PUBLIC_URL + '/themes/assets/tactileo/correct/correct.html',
  avatarIncorrectPath: process.env.PUBLIC_URL + '/themes/assets/tactileo/incorrect/incorrect.html',
  avatarHintPath: process.env.PUBLIC_URL + '/themes/assets/tactileo/hint/hint.html',
  avatarIncompletePath: process.env.PUBLIC_URL + '/themes/assets/tactileo/incomplete/incomplete.html',
};
const maskottDefault = {
  hasAnimations: false,
  colors: {
    primary: '23, 85%',
    secondary: '236, 37%',
    tertiary: '0, 0%',
    neutral: '0, 0%',
    error: '0, 79%',
    success: '145, 50%',
    lightness: colorsLightnessDefault,
  },
  defaultLightness: colorsLightnessDefault,
  contrastedLightness: colorsLightnessHighContrast,
  defaultComponentSize: COMPONENT_SIZE.SMALL,
  voiceassistant: voiceassistantDefault,
  activeBar: {
    dark: true,
    color: 'secondary',
  },
};

export const themes = {
  tactileo: {
    default: {
      id: 'T_001',
      name: 'Tactileo',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/tactileo/Tactileo_logo.svg',
      logoMobilePath: process.env.PUBLIC_URL + '/themes/assets/tactileo/Tactileo_logo_mobile.svg',
      ...avatarTactileoPath,

      colors: {
        primary: '217, 89%',
        secondary: '17, 92%',
        tertiary: '40, 90%',
        neutral: '0, 0%',
        error: '0, 80%',
        success: '144, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantDefault,
    },
    warmyellow: {
      id: 'T_001',
      name: 'Tactileo warm yellow',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/tactileo/Tactileo_logo.svg',
      ...avatarTactileoPath,
      colors: {
        primary: '217, 89%',
        secondary: '17, 92%',
        tertiary: '40, 90%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantDefault,
    },
  },
  Tactimalin: {
    default: {
      id: 'T_002',
      name: 'Tactimalin',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/inclusif/logo.png',
      hasAnimations: true,
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/inclusif/avatar-inclusif.svg',
      avatarResultPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/inclusif/avatar-inclusif.svg',
      avatarWelcomePath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/inclusif/welcome/welcome_inclusif.html',
      avatarCorrectPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/inclusif/correct/correct_inclusif.html',
      avatarIncorrectPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/inclusif/incorrect/incorrect_inclusif.html',
      avatarHintPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/inclusif/hint/hint_inclusif.html',
      avatarIncompletePath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/inclusif/incomplete/incomplete_inclusif.html',
      colors: {
        primary: '206, 17%',
        secondary: '205, 71%',
        tertiary: '60, 77%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantDefault,
    },
    primaire: {
      id: 'T_002',
      name: 'Tactimalin Primaire',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/primaire/logo-primaire.png',
      hasAnimations: true,
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/primaire/avatar-primaire.svg',
      avatarResultPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/primaire/avatar-primaire.svg',
      avatarWelcomePath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/primaire/welcome/welcome_primaire.html',
      avatarCorrectPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/primaire/correct/correct_primaire.html',
      avatarIncorrectPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/primaire/incorrect/incorrect_primaire.html',
      avatarHintPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/primaire/hint/hint_primaire.html',
      avatarIncompletePath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/primaire/incomplete/incomplete_primaire.html',
      colors: {
        primary: '152, 100%',
        secondary: '185, 93%',
        tertiary: '52, 98%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantChild,
    },
    collège: {
      id: 'T_002',
      name: 'Tactimalin Collège',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/college/logo-college.png',
      hasAnimations: true,
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/college/avatar-college.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/college/avatar-college.svg',
      avatarWelcomePath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/college/welcome/welcome_college.html',
      avatarCorrectPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/college/correct/correct_college.html',
      avatarIncorrectPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/college/incorrect/incorrect_college.html',
      avatarHintPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/college/hint/hint_college.html',
      avatarIncompletePath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/college/incomplete/incomplete_college.html',
      colors: {
        primary: '23, 79%',
        secondary: '6, 88%',
        tertiary: '52, 94%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantChild,
    },
    lycée: {
      id: 'T_002',
      name: 'Tactimalin Lycée',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/lycee/logo-lycee.png',
      hasAnimations: true,
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/lycee/avatar-lycee.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/lycee/avatar-lycee.svg',
      avatarWelcomePath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/lycee/welcome/welcome_lycee.html',
      avatarCorrectPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/lycee/correct/correct_lycee.html',
      avatarIncorrectPath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/lycee/incorrect/incorrect_lycee.html',
      avatarHintPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/lycee/hint/hint_lycee.html',
      avatarIncompletePath:
        process.env.PUBLIC_URL + '/themes/assets/tactimalin/lycee/incomplete/incomplete_lycee.html',
      colors: {
        primary: '236, 38%',
        secondary: '269, 32%',
        tertiary: '48, 51%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantDefault,
    },
    calvados: {
      id: 'T_002',
      name: 'Tactimalin Calvados',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/tactimalin/calvados/logo.png',
      ...avatarTactileoPath,
      colors: {
        primary: '338, 79%',
        secondary: '263, 46%',
        tertiary: '43, 54%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantDefault,
    },
  },
  'ÉduGO!': {
    default: {
      id: 'T_003',
      name: 'ÉduGO! Cycle 2 et 3',
      defaultLang: 'frChild',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/edugo/cycle2et3/logo.svg',
      hasQuestionCss: true,
      hasAnimations: false,
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/edugo/cycle2et3/castor_bienvenue.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/edugo/cycle2et3/castor_bienvenue.svg',
      avatarWelcomePath: process.env.PUBLIC_URL + '/themes/assets/edugo/cycle2et3/castor_bienvenue.svg',
      avatarCorrectPath: process.env.PUBLIC_URL + '/themes/assets/edugo/cycle2et3/castor_correct.svg',
      avatarIncorrectPath:
        process.env.PUBLIC_URL + '/themes/assets/edugo/cycle2et3/castor_incorrect.svg',
      avatarHintPath: process.env.PUBLIC_URL + '/themes/assets/edugo/cycle2et3/castor_indice.svg',
      avatarIncompletePath:
        process.env.PUBLIC_URL + '/themes/assets/edugo/cycle2et3/castor_incomplet.svg',
      colors: {
        primary: '30, 100%',
        secondary: '39, 76%',
        tertiary: '26, 100%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantChild,
    },
    collège: {
      id: 'T_003',
      name: 'ÉduGO! Collège',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/edugo/college/logo.svg',
      hasQuestionCss: true,
      hasAnimations: false,
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/edugo/college/chat_bienvenue.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/edugo/college/chat_bienvenue.svg',
      avatarWelcomePath: process.env.PUBLIC_URL + '/themes/assets/edugo/college/chat_bienvenue.svg',
      avatarCorrectPath: process.env.PUBLIC_URL + '/themes/assets/edugo/college/chat_correct.svg',
      avatarIncorrectPath: process.env.PUBLIC_URL + '/themes/assets/edugo/college/chat_incorrect.svg',
      avatarHintPath: process.env.PUBLIC_URL + '/themes/assets/edugo/college/chat_indice.svg',
      avatarIncompletePath: process.env.PUBLIC_URL + '/themes/assets/edugo/college/chat_incomplet.svg',
      colors: {
        primary: '174, 27%',
        secondary: '174, 52%',
        tertiary: '174, 27%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantChild,
    },
    lycée: {
      id: 'T_003',
      name: 'ÉduGO! Lycée',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/edugo/lycee/logo.svg',
      hasQuestionCss: true,
      hasAnimations: false,
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/edugo/lycee/renard_bienvenue.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/edugo/lycee/renard_bienvenue.svg',
      avatarWelcomePath: process.env.PUBLIC_URL + '/themes/assets/edugo/lycee/renard_bienvenue.svg',
      avatarCorrectPath: process.env.PUBLIC_URL + '/themes/assets/edugo/lycee/renard_correct.svg',
      avatarIncorrectPath: process.env.PUBLIC_URL + '/themes/assets/edugo/lycee/renard_incorrect.svg',
      avatarHintPath: process.env.PUBLIC_URL + '/themes/assets/edugo/lycee/renard_indice.svg',
      avatarIncompletePath: process.env.PUBLIC_URL + '/themes/assets/edugo/lycee/renard_incomplet.svg',
      colors: {
        primary: '226, 37%',
        secondary: '226, 38%',
        tertiary: '225, 41%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantDefault,
    },
  },
  michelin: {
    default: {
      id: 'T_004',
      name: 'Michelin',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/michelin/Michelin_logo.svg',
      ...avatarTactileoPath,
      colors: {
        primary: '217, 89%',
        secondary: '17, 92%',
        tertiary: '40, 90%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantChild,
    },
  },
  DominoMaths: {
    default: {
      id: 'T_005',
      name: 'Domino',
      languageSuffix: 'dominos',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/domino/Domino_logo.svg',
      hasAnimations: false,
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/domino/Domino_avatar_maths.png',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/domino/Domino_avatar.png',
      colors: {
        primary: '176, 54%',
        secondary: '331, 100%',
        tertiary: '231, 53%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantChild,
    },
  },
  DominoFrancais: {
    default: {
      id: 'T_006',
      name: 'Domino',
      languageSuffix: 'dominos',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/domino/Domino_logo.svg',
      hasAnimations: false,
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/domino/Domino_avatar_fr.png',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/domino/Domino_avatar.png',
      colors: {
        primary: '176, 54%',
        secondary: '331, 100%',
        tertiary: '231, 53%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantChild,
    },
  },
  monaco_college: {
    default: {
      id: 'T_007',
      name: 'Monaco collège',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/monaco/college_logo.png',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/monaco/Monaco_avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/monaco/Monaco_avatar.svg',
      colors: {
        primary: '355, 62%',
        secondary: '225, 6%',
        tertiary: '49, 77%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantChild,
      activeBar: {
        dark: true,
        color: 'primary',
      },
    },
  },
  monaco_lycee: {
    default: {
      id: 'T_008',
      name: 'Monaco lycée',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/monaco/lycee_logo.png',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/monaco/Monaco_avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/monaco/Monaco_avatar.svg',
      colors: {
        primary: '355, 62%',
        secondary: '225, 6%',
        tertiary: '49, 77%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      voiceassistant: voiceassistantDefault,
      activeBar: {
        dark: true,
        color: 'primary',
      },
    },
  },
  maskottSVT: {
    default: {
      id: 'T_009',
      name: 'Maskott SVT',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/svt/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/svt/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/svt/avatar.svg',
      ...maskottDefault,
    },
  },
  maskottItalien: {
    default: {
      id: 'T_010',
      name: 'Maskott Italien',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/italien/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/italien/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/italien/avatar.svg',
      ...maskottDefault,
    },
  },
  LCA: {
    default: {
      id: 'T_011',
      name: 'Maskott LCA',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/lca/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/lca/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/lca/avatar.svg',
      ...maskottDefault,
    },
  },
  maskottPhysiqueChimie: {
    default: {
      id: 'T_012',
      name: 'Maskott Physique-chimie',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/physiqueChimie/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/physiqueChimie/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/physiqueChimie/avatar.svg',
      ...maskottDefault,
    },
  },
  maskottTechnologie: {
    default: {
      id: 'T_013',
      name: 'Maskott Technologie',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/technologie/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/technologie/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/technologie/avatar.svg',
      ...maskottDefault,
    },
  },
  maskottneurosciences: {
    default: {
      id: 'T_014',
      name: 'Maskott Neurosciences',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/neurosciences/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/neurosciences/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/neurosciences/avatar.svg',
      ...maskottDefault,
    },
  },
  maskottFormation: {
    default: {
      id: 'T_015',
      name: 'Maskott Formation',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/formation/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/formation/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/formation/avatar.svg',
      ...maskottDefault,
    },
  },
  maskottCabri: {
    default: {
      id: 'T_016',
      name: 'Cabri',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/cabri/logo.png',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/cabri/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/cabri/avatar.svg',

      hasAnimations: false,
      colors: {
        primary: '0, 53%',
        secondary: '214, 29%',
        tertiary: '0, 0%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      activeBar: {
        dark: true,
        color: 'secondary',
      },
    },
  },
  'grano-svt': {
    default: {
      id: 'T_017',
      name: 'Grano Sciences SVT lycée',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/grano/Grano Sciences_SVT_large.png',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/svt/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/svt/avatar.svg',
      ...maskottDefault,
    },
  },
  'grano-pc': {
    default: {
      id: 'T_018',
      name: 'Grano Sciences Physique-chimie lycée',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/grano/Grano Sciences_PC_large.png',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/physiqueChimie/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/physiqueChimie/avatar.svg',
      ...maskottDefault,
    },
  },
  noa: {
    default: {
      id: 'T_019',
      name: 'NOA',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/noa/NOA_logo.png',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/noa/NOA_avatar.png',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/noa/NOA_avatar.png',

      hasAnimations: false,
      colors: {
        primary: '345, 100%',
        secondary: '0, 0%',
        tertiary: '0, 0%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      voiceassistant: voiceassistantDefault,
      activeBar: {
        dark: true,
        color: 'primary',
      },
    },
  },
  tactimath: {
    default: {
      id: 'T_020',
      name: 'Tactimath',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/tactimath/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/tactimath/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/tactimath/avatar.svg',

      hasAnimations: false,
      colors: {
        primary: '186, 100%',
        secondary: '23, 85%',
        tertiary: '0, 0%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      voiceassistant: voiceassistantDefault,
      activeBar: {
        dark: true,
        color: 'primary',
      },
    },
  },
  'communs-ecole': {
    default: {
      id: 'T_21',
      name: 'Communs numériques école',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/communsNumeriques/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/communsNumeriques/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/communsNumeriques/avatar.svg',
      colors: {
        primary: '300, 71%',
        secondary: '182, 71%',
        tertiary: '0, 0%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      voiceassistant: voiceassistantDefault,
      activeBar: {
        dark: true,
        color: 'primary',
      },
    },
  },
  'communs-college': {
    default: {
      id: 'T_22',
      name: 'Communs numériques collège',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/communsNumeriques/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/communsNumeriques/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/communsNumeriques/avatar.svg',
      colors: {
        primary: '300, 71%',
        secondary: '182, 71%',
        tertiary: '0, 0%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      voiceassistant: voiceassistantChild,
      activeBar: {
        dark: true,
        color: 'primary',
      },
    },
  },
  'communs-lycee': {
    default: {
      id: 'T_23',
      name: 'Communs numériques lycée',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/communsNumeriques/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/communsNumeriques/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/communsNumeriques/avatar.svg',
      colors: {
        primary: '300, 71%',
        secondary: '182, 71%',
        tertiary: '0, 0%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      voiceassistant: voiceassistantDefault,
      activeBar: {
        dark: true,
        color: 'primary',
      },
    },
  },
  esepac: {
    default: {
      id: 'T_24',
      name: 'ESEPAC',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/esepac/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/esepac/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/esepac/avatar.svg',
      colors: {
        primary: '38, 93%',
        secondary: '213, 69%',
        tertiary: '0, 0%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      voiceassistant: voiceassistantDefault,
      activeBar: {
        dark: false,
        color: 'primary',
      },
    },
  },
  spartes: {
    default: {
      id: 'T_025',
      name: 'SPARTES',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/maskott/spartes/logo.png',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/maskott/spartes/avatar.png',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/maskott/spartes/avatar.png',
      hasAnimations: false,
      colors: {
        primary: '244, 38%',
        secondary: '253, 71%',
        tertiary: '0, 0%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      voiceassistant: voiceassistantDefault,
      activeBar: {
        dark: true,
        color: 'primary',
      },
    },
  },
  acclimaterra: {
    default: {
      id: 'T_026',
      name: 'Sciences, Climat & Territoires',
      logoPath: process.env.PUBLIC_URL + '/themes/assets/acclimaterra/logo.svg',
      avatarPath: process.env.PUBLIC_URL + '/themes/assets/acclimaterra/avatar.svg',
      avatarResultPath: process.env.PUBLIC_URL + '/themes/assets/acclimaterra/avatar.svg',
      hasAnimations: false,
      colors: {
        primary: '139, 76%',
        secondary: '57, 99%',
        tertiary: '0, 0%',
        neutral: '0, 0%',
        error: '0, 79%',
        success: '145, 50%',
        lightness: colorsLightnessDefault,
      },
      defaultLightness: colorsLightnessDefault,
      contrastedLightness: colorsLightnessHighContrast,
      defaultComponentSize: COMPONENT_SIZE.SMALL,
      voiceassistant: voiceassistantDefault,
      activeBar: {
        dark: true,
        color: 'primary',
      },
    },
  },
};
